"use client";

import { useState, useEffect } from "react";

/**
 * Detects mobile devices for performance optimization.
 * Uses touch capability + coarse pointer (excludes touch-screen laptops).
 * Returns false during SSR, updates on mount.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
    const isNarrow = window.innerWidth < 768;

    // True mobile: touch + coarse pointer, or narrow viewport with touch
    setIsMobile((hasTouch && hasCoarsePointer) || (hasTouch && isNarrow));
  }, []);

  return isMobile;
}
